

































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class AreaSearch extends Vue {
  private search: string = this.$store.state.areaState.searchText
  @Prop() private total!: number

  private doAreaSearch () {
    /* キーワード検索 */
    this.$store.commit('areaState/setSearchText', this.search)
    this.$store.commit('areaState/setSortName', 'created_at')
    this.$store.commit('areaState/setSortAsc', false)

    this.$emit('get-list')
  }

  /* リセット */
  private doClear () {
    // stateリセット
    this.$store.commit('areaState/setSearchText', '')
    this.$store.commit('areaState/setSortName', 'created_at')
    this.$store.commit('areaState/setSortAsc', false)
    this.search = ''

    this.$emit('get-list')
  }
}
